/**
 * API Module Exports
 * Central export point for all API modules
 */

// Load environment variables
import "dotenv/config";

// Core exports
export {
  API_CONFIG,
  API_ENDPOINTS,
  getApiUrl,
  getImageUrl,
  buildQueryString,
} from "./core/api.config";
export type {
  ApiResponse,
  ApiError,
  ApiClientResponse,
  QueryParams,
  RequestOptions,
  WhereCondition,
  WhereOperator,
  BaseDocument,
  LandingConfig,
  Media,
  GlobalSettings,
  PaginationMeta,
  UploadOptions,
} from "./core/api.types";

// Export NewsItem from newsType
export type { NewsItem, NewsImage } from "@/types/newsType";
export { api, apiClient, ApiClient } from "./core/api.client";
export {
  ApiException,
  NetworkError,
  NotFoundError,
  ValidationError,
  RateLimitError,
  ServerError,
  isNetworkError,
  isValidationError,
  parseApiError,
  handleApiError,
  formatErrorMessage,
  shouldRetry,
  getRetryDelay,
} from "./core/api.errors";

// Collections exports
export {
  CollectionApi,
  LandingConfigApi,
  MediaApi,
  createCollectionApi,
  landingConfigApi,
  mediaApi,
  collections,
} from "./collections/collections.api";
export { NewsApi, newsApi } from "./collections/newsApi";
export {
  LibraryApi,
  libraryApi,
  type LibraryApiResponse,
} from "./collections/libraryApi";
export { CareerApi, careerApi, careers } from "./collections/careerApi";
export {
  LandingCvApi,
  landingCvApi,
  landingCv,
} from "./collections/landingCvApi";

// Import LibraryArticle from types instead of API
export type { LibraryArticle } from "@/types/libraryType";
export type { Career, CareerFilters } from "@/types/careerType";
export type { PolicyGlobal } from "@/types/policyType";

// Globals exports
export {
  GlobalApi,
  SiteSettingsApi,
  NavigationApi,
  type NavigationItem,
  type NavigationGlobal,
  FooterApi,
  type FooterGlobal,
  PolicyGlobalApi,
  ContactGlobalApi,
  createGlobalApi,
  siteSettingsApi,
  navigationApi,
  footerApi,
  policyGlobalApi,
  contactGlobalApi,
  globals,
} from "./globals/globals.api";

// Import instances for default export
import { apiClient } from "./core/api.client";
import { formatErrorMessage } from "./core/api.errors";
import { landingConfigApi, mediaApi } from "./collections/collections.api";
import { newsApi } from "./collections/newsApi";
import { libraryApi } from "./collections/libraryApi";
import { careerApi } from "./collections/careerApi";
import { landingCvApi } from "./collections/landingCvApi";
import {
  siteSettingsApi,
  navigationApi,
  footerApi,
  policyGlobalApi,
  contactGlobalApi,
} from "./globals/globals.api";

// Default export with all APIs organized by category
const ktxApi = {
  // Core client
  client: apiClient,

  // Collections
  collections: {
    landingConfig: landingConfigApi,
    media: mediaApi,
    news: newsApi,
    library: libraryApi,
    career: careerApi,
    landingCv: landingCvApi,
  },

  // Globals
  globals: {
    siteSettings: siteSettingsApi,
    navigation: navigationApi,
    footer: footerApi,
    policy: policyGlobalApi,
    contact: contactGlobalApi,
  },

  // Utilities
  utils: {
    formatError: formatErrorMessage,
  },
};

export default ktxApi;
